const COOKIE_NAME = 'cleancal_cookie_consent';

export interface ConsentPreferences {
  necessary: boolean;
  functional: boolean;
  analytics: boolean;
}

function getCookieValue(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export function getConsentPreferences(): ConsentPreferences | null {
  const value = getCookieValue(COOKIE_NAME);
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return value === 'true'
      ? { necessary: true, functional: true, analytics: true }
      : null;
  }
}

export function hasConsentFor(category: keyof ConsentPreferences): boolean {
  const prefs = getConsentPreferences();
  if (!prefs) return category === 'necessary';
  return prefs[category];
}

/** The window event the cookie banner (src/components/CookieConsentBanner.tsx) dispatches when the visitor answers, with the new preferences. */
export const CONSENT_CHANGED_EVENT = 'consentChanged';

/** Calls `listener` each time the visitor answers the cookie banner (no page reload). Returns the unsubscribe function. */
export function onConsentChange(listener: (prefs: ConsentPreferences | null) => void): () => void {
  const handler = (e: Event) => listener((e as CustomEvent<ConsentPreferences | undefined>).detail ?? getConsentPreferences());
  window.addEventListener(CONSENT_CHANGED_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
}

/** The platform console is staff-only chrome with no visitor to ask: the cookie banner would only cover its screens. */
export function showsCookieBanner(pathname: string): boolean {
  return !(pathname === '/platform' || pathname.startsWith('/platform/'));
}
